import { createBusinessPartnerResponseDtoKindEnum } from "~/gen/api/types/CreateBusinessPartnerResponseDto.ts"

export const BusinessPartnerKind = {
  CONTACT: createBusinessPartnerResponseDtoKindEnum.contact,
  ON_BEHALF: createBusinessPartnerResponseDtoKindEnum.on_behalf,
} as const

export type BusinessPartnerKind =
  (typeof BusinessPartnerKind)[keyof typeof BusinessPartnerKind]
